// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-5a3ef89a]{align-items:center;display:flex;flex-direction:row;font-weight:500;justify-content:flex-start}.dates[data-v-5a3ef89a],.title[data-v-5a3ef89a]{color:var(--colour-dark-blue)}.dates[data-v-5a3ef89a]{font-weight:700}.icon[data-v-5a3ef89a]{height:1.3em;margin-right:.35em;width:auto}svg[data-v-5a3ef89a]{height:auto;width:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
